import { SiteIdOverrideConfig } from "stores/wizard/config";

export const siteId1146: SiteIdOverrideConfig = {
  global: {
    heroImageSrc: "https://forever.travel-assets.com/flex/flexmanager/images/2020/09/04/AARP_Hero_(1).jpeg",
  },
  package: {
    heading: {
      lobNotSupported: "wizard.package.invalid.header.lobNotSupported.text",
    },
  },
  car: {
    iHaveDiscount: "wizard.car.having.brand.title",
  },
};
